import { baseSource } from "./base-source.js";
export const h3TilesetSource = async function (options) {
    const { tableName } = options;
    const urlParameters = { name: tableName };
    return baseSource('tileset', options, urlParameters);
};
